import type { ICarePlan } from "@domain/CarePlan";
import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";
import { WorkOrderType } from "@domain/CarePlan/WorkOrders/WorkOrderType";

export class TyreCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Tyres, ConfigurationType.Monthly );
        this.icon = 'dashboard:tyres';
        this.ordinal = 3;
        this.initialise();
    }

    /**
     * Applies the care plan state to the condition
     * @param carePlan 
     */
    applyCarePlan( carePlan: ICarePlan )
    {
        this.workOrderConfiguration = carePlan.getItem( WorkOrderType.TyreReplacement );
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: "Tyres",
            shortName: 'Replacement',
            longName: "Tyre Condition",
            intervalJustCompletedMessage: "Tyres have just been replaced",
            cta: "Find a tyre specialist",
            maintenanceVerb: 'Check Tyre Condition',
            protectedByLabel: 'Your tyres are protected by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    protected override getIntervalDescription()
    {
        if( this.averageOdometerInterval == 0 ) return 'n/a';
        return `Depending on use, tyres need to be replaced ${ super.getIntervalDescription( this.vehicle, this ) }`;
    }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        switch( this.state )
        {
            case ConditionState.Due: return 'Check your tyre condition and replace any worn tyres as soon as possible';
            case ConditionState.Overdue: return 'Check your tyre condition and replace any worn tyres as soon as possible';
            case ConditionState.Critical: return 'Check your tyre condition and replace any worn tyres as soon as possible';
            default: return '';
        }
    }

}
